import {BUILD_TYPE, getBuildType} from '@voltmoney/micro-frontend';
import {Platform} from 'react-native';
import {getParameters} from '@voltmoney/platform';
import {StoreKey} from './api';
import {addDaysToEpochTime} from './util';

export enum Links {
  BAJAJ = 'https://www.bajajfinserv.in/',
  KFIN = 'https://www.kfintech.com/',
  CAMS = 'https://www.camsonline.com/',
  NSDL = 'https://nsdl.co.in/',
  CDSL = 'https://www.cdslindia.com/',
}

export const partnerHelplineNumber = '9611749295';

export const WhatsAppLink = {
  help: `https://wa.me/91${partnerHelplineNumber}`,
  helpPartner: `https://api.whatsapp.com/send?phone=91${partnerHelplineNumber}`,
};

export const AppLink =
  getBuildType() === BUILD_TYPE.PARTNER_PRODUCTION
    ? 'https://app.voltmoney.in/'
    : 'https://app.staging.voltmoney.in/';

export const PartnerLink =
  getBuildType() === BUILD_TYPE.PARTNER_PRODUCTION
    ? 'https://voltmoney.in/partner/'
    : 'https://staging.voltmoney.in/partner/';

export const GoogleSheetLink = {
  Complete_Profile:
    'https://docs.google.com/forms/d/1AcsXJVwPy0tglKMfp4_qjZ5OtV_jd9vrKQZlMTcGZGQ/viewform',
};

export const GoogleSheetParams = {
  NAME: 'entry.304195377',
  EMAIL: 'entry.782070289',
  PHONE: 'entry.1019633021',
  PARTNER_ID: 'entry.1787999657',
};

export enum REPORTING_TYPE {
  EMAIL = 'EMAIL',
}

export const helpLineNumberLink = 'tel:+919611749097';

export enum GoogleUtmParams {
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_CONTENT = 'utm_content',
  UTM_ID = 'utm_id',
  UTM_MEDIUM = 'utm_medium',
  UTM_SOURCE = 'utm_source',
}

export const UTM_expiry_days = 28;

export const isGoogleUTMParams: (param: string) => boolean = param => {
  if (
    param === GoogleUtmParams.UTM_SOURCE ||
    param === GoogleUtmParams.UTM_CONTENT ||
    param === GoogleUtmParams.UTM_ID ||
    param === GoogleUtmParams.UTM_CAMPAIGN ||
    param === GoogleUtmParams.UTM_MEDIUM
  ) {
    return true;
  }
  return false;
};

export const getParamsLink = (url: string) => {
  const params = Platform.OS === 'web' ? getParameters(url) : {};

  let resultString = '';
  let localStoredParams = {};

  // check if params exist in localstorage if not present in query string
  const utm_campaign = params?.utm_campaign;
  const utm_content = params?.utm_content;
  const utm_id = params?.utm_id;
  const utm_medium = params?.utm_medium;
  const utm_source = params?.utm_source;
  let cachedUtm = localStorage.getItem(StoreKey.UTM_PARAMS);

  if (utm_campaign || utm_content || utm_id || utm_medium || utm_source) {
    Object.keys(params).forEach(param => {
      //store google utm params in localStorage
      if (isGoogleUTMParams(param)) {
        localStoredParams = {
          ...localStoredParams,
          time: addDaysToEpochTime(Date.now().valueOf(), UTM_expiry_days),
          [`${param}`]: params[param],
        };
      }
      if (param !== 'time') {
        resultString += `${param}=${params[`${param}`]}&`;
      }
    });
    localStorage.removeItem(StoreKey.UTM_PARAMS);
    localStoredParams &&
      localStorage.setItem(
        StoreKey.UTM_PARAMS,
        JSON.stringify(localStoredParams),
      );
  } else {
    if (cachedUtm) {
      const cachedUtmJson = JSON.parse(cachedUtm);
      if (cachedUtmJson?.time && Date.now().valueOf() <= cachedUtmJson.time) {
        Object.keys(cachedUtmJson).forEach(param => {
          //store google utm params in localStorage
          if (param !== 'time') {
            resultString += `${param}=${cachedUtmJson[`${param}`]}&`;
          }
        });
      } else {
        //remove google utm params in localStorage when token expires
        localStorage.removeItem(StoreKey.UTM_PARAMS);
      }
    }
  }
  return `?${resultString}`;
};

export enum PartnerAccountType {
  INDIVIDUAL = 'INDIVIDUAL',
  ORGANISATION = 'ORGANISATION',
  EXTERNAL_MARKETING = 'EXTERNAL_MARKETING',
}

export const interestRate = '9.95% p.a';
